<template>
    <form @submit.prevent="save()">
        <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-3 m-b-15" :class="{'has-error': errors['type']}">
                <label class="control-label">{{ $t('type') }}</label>
                <pml-select v-model="record.type" :options="types"></pml-select>
                <span class="error" v-if="errors['type']">{{ errors['type'][0] }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3 m-b-15" :class="{'has-error': errors['description']}">
                <label class="control-label">{{ $t('description') }}</label>
                <input type="text" class="form-control" v-model="record.description">
                <span class="error" v-if="errors['description']">{{ errors['description'][0] }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3 m-b-15" :class="{'has-error': errors['value']}">
                <label class="control-label">{{ $t('value') }}</label>
                <label class="input-group">
                    <pml-numeric v-model="record.value"></pml-numeric>
                    <span class="input-group-addon">{{ getCurrency(tenant.currency_id).symbol }}</span>
                </label>
                <span class="error" v-if="errors['value']">{{ errors['value'][0] }}</span>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-3 t_right m-t-23">
                <span class="btn btn-white" @click.prevent="clear">{{ $t('cancel') }}</span>
                <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import bus from 'utils/events/bus'
    import { trans } from 'utils/helpers/translation'
    import { create, update } from 'services/quotation-charges'
    import { findCurrency } from 'utils/helpers/find-store'
    import { mapGetters } from 'vuex'
    import { cloneDeep } from 'lodash'

    export default {
        name: 'QuotationCharge',
        data () {
            return {
                isSaving: false,
                record: {
                    type: ''
                },
                errors: {}
            }
        },
        created () {
            bus.$on('editCharge', item => { this.record = cloneDeep(item) })
        },
        destroyed () {
            bus.$off('editCharge')
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'types': 'getQuotationChargeTypes'
            })
        },
        methods: {
            getCurrency: (id) => findCurrency(id),
            clear () {
                this.record = {
                    type: ''
                }
                this.errors = []
            },
            request () {
                return !this.record.id
                    ? create(this.$route.params.id, this.$route.params.quotation, this.record)
                    : update(this.$route.params.id, this.$route.params.quotation, this.record.id, this.record)
            },
            save () {
                this.isSaving = true

                this.request()
                    .then(() => {
                        this.clear()
                        Notify.success(trans('the_record_has_been_saved'))
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/charges/Form.vue